import { render, staticRenderFns } from "./daily-consumption.vue?vue&type=template&id=452702a0"
import script from "./daily-consumption.vue?vue&type=script&lang=js"
export * from "./daily-consumption.vue?vue&type=script&lang=js"
import style0 from "./daily-consumption.vue?vue&type=style&index=0&id=452702a0&prod&lang=scss"
import style1 from "./daily-consumption.vue?vue&type=style&index=1&id=452702a0&prod&midia=print&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports